import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import {
  RangePicker,
  color as colors,
  theme
} from '@workboard/wobo-ui';
import Template from './Presets';

const Label = styled('span')``;

const datePickerId = uuid();

const Toolbar = memo(
  ({ className, id, timeframe = {}, options = {}, onChange = () => {}, onReset = () => {} }) => {
    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [min, setMin] = useState();
    const [max, setMax] = useState();
    const [key, setKey] = useState(uuid());

    useEffect(() => {
      if (timeframe.start && timeframe.end) {
        setStart(timeframe.start);
        setEnd(timeframe.end);
        setMin(options.min);
        setMax(options.max);
      }
  }, [timeframe, options]);

    const handleRangeChange = useCallback(
      ({ start: start, end: end }) => {
        if (start && end) {
          const s = start.getTime(),
            e = end.getTime();
          if (s > e) {
            setStart(end);
            setEnd(null);
          } else {
            setStart(start);
            setEnd(end);
          }
        }
      },
      [onChange, setStart, setEnd]
    );

    const handleDismiss = useCallback(() => {
      setKey(uuid()); // Hide calendar picker.
      setStart(timeframe.start);
      setEnd(timeframe.end);
    }, [timeframe, setEnd, setStart]);

    const handleReset = useCallback(() => {
      setKey(uuid()); // Hide calendar picker.
      onReset();
    }, [onReset]);
  
    const handleSubmit = useCallback(() => {
      setKey(uuid()); // Hide calendar picker.
      onChange({ start: start, end: end });
    }, [onChange, start, end]);

    const Presets = useCallback(
      (props) => (
        <Template
          {...props}
          onDismiss={handleDismiss}
          onReset={handleReset}
          onSubmit={handleSubmit}
        />
      ),
      [handleDismiss, handleSubmit]
    );

    return timeframe.start && timeframe.end ? (
      <div className={className}>
        <Label id={datePickerId}>Timeframe</Label>
        <RangePicker
          aria-describedby={datePickerId}
          key={key}
          displayFormat={() => 'MMM D, YYYY'}
          start={start}
          end={end}
          // TODO
          // isOutsideRange={day => {
          //   const minDate = min < start ? moment(min) : null, maxDate = max > end ? moment(max) : null;
          //   return day.isBefore(minDate) || day.isAfter(maxDate);
          // }}
          onChange={handleRangeChange}
          onOutsideClick={handleDismiss}
          showClearDates={false}
          presetsTemplate={Presets}
          keepOpen
          anchorDirection="right"
        />
      </div>
    ) : (
      ''
    );
  }
);

export default styled(Toolbar)`
  align-items: center;
  display: flex;

  ${Label} {
    transform: translateY(4px);
    ${theme('--font-normal')};
    color: ${colors('--black-opacity-60')};
    font-weight: bold;
    margin-right: 12px;
  }

  ${RangePicker} {
    & .DateInput {
      input {
        width: 85px;
      }
    }
  }
`;
